import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { ArrowLeft } from 'lucide-react';
import RichTextEditor from '../components/RichTextEditor';

export default function NewTicket() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [devices, setDevices] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [contactId, setContactId] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [loading, setLoading] = useState(false);
  const [ownerType, setOwnerType] = useState('customer');
  const [suppliers, setSuppliers] = useState([]);
  const [supplierId, setSupplierId] = useState('');
  const [supplierContactId, setSupplierContactId] = useState('');
  const [supplierContacts, setSupplierContacts] = useState([]);

  useEffect(() => {
    api.get('/customers').then(res => {
      setCustomers(res.data.filter(c => c.is_active));
    }).catch(() => toast.error('Fehler beim Laden der Kunden'));
    api.get('/suppliers').then(res => {
      setSuppliers((res.data.suppliers || []).filter(s => s.is_active));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!customerId) { setContacts([]); setContactId(''); setDevices([]); setDeviceId(''); return; }
    api.get('/contacts/customer/' + customerId).then(res => {
      setContacts(res.data.filter(c => c.is_active));
      const primary = res.data.find(c => c.is_primary);
      setContactId(primary ? primary.id : '');
    }).catch(() => {});
    api.get('/devices?customer_id=' + customerId).then(res => {
      setDevices(res.data);
    }).catch(() => {});
  }, [customerId]);
  useEffect(() => {
    if (!supplierId) { setSupplierContacts([]); setSupplierContactId(''); return; }
    api.get('/supplier-contacts/supplier/' + supplierId).then(res => {
      setSupplierContacts(res.data);
      const primary = res.data.find(sc => sc.is_primary);
      setSupplierContactId(primary ? primary.id : '');
    }).catch(() => {});
  }, [supplierId]);

  const handleSubmit = async () => {
    if (!title.trim() || (ownerType === 'customer' && !customerId) || (ownerType === 'supplier' && !supplierId)) {
      toast.error('Titel und Besitzer sind erforderlich');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/tickets', {
        title,
        description,
        customer_id: ownerType === 'customer' ? parseInt(customerId) : null,
        contact_id: ownerType === 'customer' && contactId ? parseInt(contactId) : null,
        supplier_id: ownerType === 'supplier' ? parseInt(supplierId) : null,
        supplier_contact_id: ownerType === 'supplier' && supplierContactId ? parseInt(supplierContactId) : null,
        device_id: ownerType === 'customer' && deviceId ? parseInt(deviceId) : null,
      });
      toast.success('Ticket erstellt');
      navigate('/tickets/' + res.data.id);
    } catch (err) {
      toast.error('Fehler beim Erstellen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={() => navigate('/tickets')}
        className="flex items-center gap-2 text-sm text-gray-400 hover:text-gray-600 mb-4 transition-colors"
      >
        <ArrowLeft size={16} /> Zurueck
      </button>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Neues Ticket</h2>
      <div className="bg-white rounded-2xl border border-gray-100 p-6 max-w-2xl shadow-sm space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Titel *</label>
          <input
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="Kurzbeschreibung des Problems"
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 bg-gray-50"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Beschreibung</label>
          <RichTextEditor
            value={description}
            onChange={setDescription}
            placeholder="Ausfuehrliche Beschreibung des Problems..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Typ *</label>
          <div className="flex gap-2 mb-3">
            <button type="button" onClick={() => { setOwnerType('customer'); setSupplierId(''); setSupplierContactId(''); }}
              className={'px-4 py-2 rounded-xl text-sm font-medium border transition-colors ' + (ownerType === 'customer' ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-600 border-gray-200 hover:border-primary-400')}>
              Kunde
            </button>
            <button type="button" onClick={() => { setOwnerType('supplier'); setCustomerId(''); setContactId(''); setDeviceId(''); }}
              className={'px-4 py-2 rounded-xl text-sm font-medium border transition-colors ' + (ownerType === 'supplier' ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-600 border-gray-200 hover:border-primary-400')}>
              Lieferant
            </button>
          </div>
          {ownerType === 'customer' ? (
          <select
            value={customerId}
            onChange={e => setCustomerId(e.target.value)}
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 bg-gray-50"
          >
            <option value="">Kunde auswaehlen...</option>
            {customers.map(c => (
              <option key={c.id} value={c.id}>{c.name} ({c.customer_number})</option>
            ))}
          </select>
          ) : (
          <select value={supplierId} onChange={e => setSupplierId(e.target.value)}
            className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500">
            <option value="">Lieferant auswaehlen...</option>
            {suppliers.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
          )}
        </div>
        {contacts.length > 0 && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ansprechpartner</label>
            <select
              value={contactId}
              onChange={e => setContactId(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 bg-gray-50"
            >
              <option value="">Kein Ansprechpartner</option>
              {contacts.map(c => (
                <option key={c.id} value={c.id}>{c.first_name} {c.last_name}{c.is_primary ? ' (Hauptkontakt)' : ''}</option>
              ))}
            </select>
          </div>
        )}
        {devices.length > 0 && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Geraet</label>
            <select
              value={deviceId}
              onChange={e => setDeviceId(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 bg-gray-50"
            >
              <option value="">Kein Geraet</option>
              {devices.map(d => (
                <option key={d.id} value={d.id}>
                  {d.display_name} ({d.offline ? 'Offline' : 'Online'})
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="flex gap-3 pt-2">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-6 py-2.5 rounded-xl transition-colors disabled:opacity-50 shadow-sm"
          >
            {loading ? 'Wird erstellt...' : 'Ticket erstellen'}
          </button>
          <button
            onClick={() => navigate('/tickets')}
            className="border border-gray-200 text-gray-600 hover:bg-gray-50 text-sm font-medium px-6 py-2.5 rounded-xl transition-colors"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}
